import { debounce } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';
import { logger } from '@/lib/logger';

enum ScrollDirection {
  up = 'up',
  down = 'down',
}

export default function useCollectionPageScrollEvent() {
  const [showTopBar, setTopBarVisibility] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let previousScrollYPosition = window.scrollY;

    const scrolledMoreThanThreshold = (currentScrollYPosition: number) =>
      currentScrollYPosition > 120;

    const isScrollingUp = (currentScrollYPosition: number) =>
      currentScrollYPosition > previousScrollYPosition &&
      !(previousScrollYPosition > 0 && currentScrollYPosition === 0) &&
      !(currentScrollYPosition > 0 && previousScrollYPosition === 0);

    const updateScrollDirection = () => {
      setIsScrolling(true);
      const currentScrollYPosition = window.scrollY;

      if (scrolledMoreThanThreshold(currentScrollYPosition)) {
        const newScrollDirection = isScrollingUp(currentScrollYPosition)
          ? ScrollDirection.down
          : ScrollDirection.up;

        if (
          (newScrollDirection === 'down' || newScrollDirection === 'up') &&
          containerRef.current
        ) {
          if (previousScrollYPosition < containerRef.current?.scrollHeight)
            setTopBarVisibility(true);
          else setTopBarVisibility(false);
        } else {
          setTopBarVisibility(false);
        }
      } else {
        setTopBarVisibility(false);
      }
      previousScrollYPosition =
        currentScrollYPosition > 0 ? currentScrollYPosition : 0;
      debounce(() => logger.debug('END SCROLL'), 100);
    };

    const onScroll = () => window.requestAnimationFrame(updateScrollDirection);

    logger.debug('onScroll', onScroll);
    window.addEventListener('scroll', onScroll);
    logger.debug('isScrolling', isScrolling);

    return () => {
      setTopBarVisibility(false);
      setIsScrolling(false);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return {
    shouldShowTopBar: showTopBar,
    isScrolling,
    containerRef,
  };
}
